export default {
  en: {
    all: 'All',
    muted: 'Muted',
  },
};
